<template>
  <div class="element-box">
    <div class="row">

      <div class="col-lg-8 col-sm-12">
        <div class="d-inline-block">
          <h5>{{ travelExpenses.year }}, {{ $t(`calendar.months_number_key.${travelExpenses.month}`) }}</h5>

          <p style="font-size: 18px; margin-bottom: 6px;"><strong>Mitarbeiter:</strong>
            {{ travelExpenses?.user?.firstName }} {{ travelExpenses?.user?.lastName }}
          </p>
          <p style="font-size: 15px; margin-bottom: 6px;"><strong>Gesamte Kilometer:</strong>
            {{ travelExpenses?.distance }} km
          </p>
          <p style="font-size: 15px; margin-bottom: 6px;"><strong>Kilometerpauschale:</strong>
            {{ travelExpenses?.price }} €/km
          </p>
          <p style="font-size: 15px; margin-bottom: 15px;"><strong>Auszahlungsbetrag:</strong>
            {{ travelExpenses?.total }} €
          </p>
          <h6>
            Status:
            <span v-if="travelExpenses.status === 'draft'" class="status-pill yellow p-2 ml-1"
                  data-toggle="tooltip"></span>
            <span v-if="travelExpenses.status === 'modification'" class="status-pill red p-2 ml-1"
                  data-toggle="tooltip"></span>
            <span v-if="travelExpenses.status === 'pending'" class="status-pill yellow p-2 ml-1"
                  data-toggle="tooltip"></span>
            <span v-if="travelExpenses.status === 'approved_by_coordinator'" class="status-pill p-2 ml-1"
                  style="background-color: mediumseagreen" data-toggle="tooltip"></span>
            <span v-if="travelExpenses.status === 'approved'" class="status-pill green p-2 ml-1"
                  data-toggle="tooltip"></span>
            <span class="ml-2 mb-1">{{ travelExpenses.statusTranslated }}</span>
          </h6>
        </div>
      </div>

      <div class="col-lg-4 text-right d-flex flex-column justify-content-between">
        <div class="d-flex justify-content-end">
          <CreateButton
              variant="primary"
              v-if="travelExpenses?.status === 'draft' || travelExpenses?.status === 'modification'"
              :label="$t('travel_expenses.create')"
              @click="createTravelExpenses">
          </CreateButton>
        </div>

        <div class="d-flex justify-content-end"
             v-if="travelExpenses?.status !== 'draft' && travelExpenses?.status !== 'modification'">
          <a target="_blank"
             class="btn portal_pdf_export"
             @click="downloadFile(`/travel-expenses/details-export-pdf/${travelExpenses.id}`, undefined, )">
            <img src="../../../../../assets/img/pdf_icon_version4.png" alt="" width="50" height="63"/>
            <p class="mt-2 mb-0">Fahrtkosten PDF</p>
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {downloadFile} from "@/shared/functions";
import CreateButton from "@/components/CreateButton.vue";
import {defineEmits, defineProps, toRef} from "vue";

const emit = defineEmits(['createTravelExpenses']);

const props = defineProps({
  travelExpenses: {
    type: Object,
    required: false,
  },
});

const travelExpenses = toRef(props, 'travelExpenses');

function createTravelExpenses() {
  emit('createTravelExpenses');
}
</script>
<style scoped>
</style>